export const SCREEN_SIZES = {
  MEDIUM: 768,
  TABLET: 1200,
};
